import { render, staticRenderFns } from "./consumables.vue?vue&type=template&id=16b8e6f6&"
import script from "./consumables.vue?vue&type=script&lang=js&"
export * from "./consumables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports